// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Sh2B","title":"Info_title__19XDo","selects":"Info_selects__eBxwA","requiredAsterisk":"Info_requiredAsterisk__3KvEP"};